import { CanDeactivateFn } from '@angular/router';

/** A page that can have edits the user has not saved and can ask whether to leave (kept as an interface so the route does not pull the lazy page into the main bundle). */
export interface ConfirmsLeave {
  confirmLeave(): boolean | Promise<boolean>;
}

/**
 * Leaving the contract page (another page, or another contract, which reuses the component and still runs this guard) with unsaved changes asks first, in the app's confirm dialog.
 * Closing the browser tab is covered by the page's own `beforeunload` listener.
 */
export const contractUnsavedGuard: CanDeactivateFn<ConfirmsLeave> = (component) => component.confirmLeave();
